module.exports = __webpack_public_path__ + "img/logo-vector.428ef508.svg";